import { render } from "./stack_active_set_B.vue?vue&type=template&id=b52386b6&scoped=true"
import script from "./stack_active_set_B.vue?vue&type=script&lang=js"
export * from "./stack_active_set_B.vue?vue&type=script&lang=js"

import "./stack_active_set_B.vue?vue&type=style&index=0&id=b52386b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52386b6"]])

export default __exports__